import moment from "moment";
import Stack from "@mui/material/Stack";
import FormControl from "@mui/material/FormControl";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListSubheader from "@mui/material/ListSubheader";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import { useAppStore } from "../../store/appStore";

const Options = () => {
	const top21TrendsRangeStart = useAppStore(
		(state) => state.top21TrendsRangeStart
	);
	const setTop21TrendsRangeStart = useAppStore(
		(state) => state.setTop21TrendsRangeStart
	);
	const top21TrendsRangeEnd = useAppStore((state) => state.top21TrendsRangeEnd);
	const setTop21TrendsRangeEnd = useAppStore(
		(state) => state.setTop21TrendsRangeEnd
	);
	const top21TrendsInterval = useAppStore((state) => state.top21TrendsInterval);
	const setTop21TrendsInterval = useAppStore(
		(state) => state.setTop21TrendsInterval
	);
	const top21TimeFilter = useAppStore((state) => state.top21TimeFilter);
	const setTop21TimeFilter = useAppStore(
		(state) => state.setTop21TimeFilter
	);

	const handleChange = (event) => {
		if (event.target.name === "top21TrendsRangeStart") {
			setTop21TrendsRangeStart(event.target.value);
		} else if (event.target.name === "top21TrendsRangeEnd") {
			setTop21TrendsRangeEnd(event.target.value);
		} else if (event.target.name === "top21TrendsInterval") {
			setTop21TrendsInterval(event.target.value);
		} else if (event.target.name === "top21TimeFilter") {
			setTop21TimeFilter(event.target.value);
		}
	};

	const timeRangeStartOptions = [];
	let time = moment.unix(1661068800);
	const nowUnixTime = moment().unix();
	const maxUnixTime = nowUnixTime > 1661612400 ? 1661612400 : nowUnixTime;
	while (time.unix() < maxUnixTime) {
		timeRangeStartOptions.push(time.unix());
		time = moment(time).add(30, "minutes");
	}
	const timeRangeEndOptions = timeRangeStartOptions.filter(
		(t) => t > top21TrendsRangeStart
	);

	return (
		<List subheader={<ListSubheader component="div">圖表選項</ListSubheader>}>
			<ListItem>
				<FormControl size="small" fullWidth>
					<InputLabel>時間間距</InputLabel>
					<Select
						name="top21TrendsInterval"
						value={top21TrendsInterval}
						label="時間間距"
						onChange={handleChange}
					>
						<MenuItem value="01-minutes">1 分鐘</MenuItem>
						<MenuItem value="05-minutes">5 分鐘</MenuItem>
						<MenuItem value="10-minutes">10 分鐘</MenuItem>
						<MenuItem value="15-minutes">15 分鐘</MenuItem>
						<MenuItem value="20-minutes">20 分鐘</MenuItem>
						<MenuItem value="30-minutes">半小時</MenuItem>
						<MenuItem value="01-hour">小時</MenuItem>
						<MenuItem value="02-hours">2 小時</MenuItem>
						<MenuItem value="03-hours">3 小時</MenuItem>
						<MenuItem value="04-hours">4 小時</MenuItem>
						<MenuItem value="06-hours">6 小時</MenuItem>
						<MenuItem value="12-hours">半日</MenuItem>
						<MenuItem value="01-day">一日</MenuItem>
					</Select>
				</FormControl>
			</ListItem>
			<ListItem>
				<FormControl size="small" fullWidth>
					<InputLabel>時間篩選</InputLabel>
					<Select
						name="top21TimeFilter"
						value={top21TimeFilter}
						label="時間篩選"
						onChange={handleChange}
					>
						<MenuItem value="last-24-hours">最後 24 小時</MenuItem>
						<MenuItem value="last-12-hours">最後 12 小時</MenuItem>
						<MenuItem value="last-6-hours">最後 6 小時</MenuItem>
						<MenuItem value="last-1-hours">最後 1 小時</MenuItem>
						<MenuItem value="last-30-minutes">最後 30 分鐘</MenuItem>
						<MenuItem value="custom">自選間距</MenuItem>
					</Select>
				</FormControl>
			</ListItem>
			{top21TimeFilter === "custom" && (
				<ListItem>
					<Stack flex={1} spacing={1}>
						<FormControl size="small" fullWidth>
							<Select
								name="top21TrendsRangeStart"
								value={top21TrendsRangeStart}
								onChange={handleChange}
							>
								{timeRangeStartOptions.map((t) => (
									<MenuItem key={`start_${t}`} value={t}>
										{moment.unix(t).format("DD MMM HH:mm")}
									</MenuItem>
								))}
							</Select>
						</FormControl>
						<Stack direction="row" spacing={1} alignItems="center">
							<Typography>至</Typography>
							<FormControl size="small" fullWidth>
								<Select
									name="top21TrendsRangeEnd"
									value={top21TrendsRangeEnd || "-"}
									onChange={handleChange}
								>
									{timeRangeEndOptions.map((t) => (
										<MenuItem key={`end_${t}`} value={t}>
											{moment.unix(t).format("DD MMM HH:mm")}
										</MenuItem>
									))}
									<MenuItem key={`end_null`} value="-">
										現在
									</MenuItem>
								</Select>
							</FormControl>
						</Stack>
					</Stack>
				</ListItem>
			)}
		</List>
	);
};

export default Options;
